import { Flex } from '@sequencehq/core-components'
import { ReactNode } from 'react'

/**
 * Places a banner in the quote column, in line with the quote's content and
 * spaced from whatever sits above it.
 */
export const QuoteContentBanner = ({
  children,
  'data-testid': dataTestId
}: {
  children: ReactNode
  'data-testid'?: string
}) => (
  <Flex marginX="55px" marginTop="16px" data-testid={dataTestId}>
    {children}
  </Flex>
)
